<template>
  <v-container fluid class="pa-6">
    <v-row justify="space-between" align="center" class="mb-6">
      <h1 class="font-weight-bold" style="font-size: 2em;">Gerenciar Notificações</h1>
    </v-row>

    <v-card class="pa-6 mb-6 elevation-3" outlined shaped>
      <div class="font-weight-bold mb-4" style="font-size: 1.2em;">Enviar Notificação</div>
      
      <v-form @submit.prevent="enviarNotificacao">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="titulo"
              label="Título"
              outlined
              maxlength="50"
              counter="50"
              dense
              clearable
              prepend-inner-icon="mdi-bell"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
             <v-select
              v-model="destinatario"
              :items="tiposDeDestinatario"
              label="Enviar Para"
              dense
              outlined
              prepend-inner-icon="mdi-account-group"
            ></v-select>
          </v-col>
        </v-row>

        <v-row v-if="mostrarSelecaoEspecifica">
          <v-col cols="12">
            <v-autocomplete
              v-model="destinatarioSelecionado"
              :items="listaSelecionavel"
              :label="labelSelecaoEspecifica"
              item-text="nome"
              item-value="id_pessoa"
              outlined
              dense
              clearable
              chips
              deletable-chips
              prepend-inner-icon="mdi-magnify"
              :search-input.sync="buscaTermo"
              @update:search-input="buscarPessoas"
              @change="limparBusca"
            >
              <template v-slot:item="data">
                <v-list-item-avatar>
                  <v-img v-if="data.item.fotoUrl" :src="data.item.fotoUrl"></v-img>
                  <v-icon v-else>mdi-account-circle</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-html="data.item.nome"></v-list-item-title>
                </v-list-item-content>
              </template>

              <template v-slot:selection="data">
                <v-chip
                  close
                  @click:close="destinatarioSelecionado = null"
                  class="chip-transparente"
                >
                  <v-avatar left>
                    <v-img v-if="data.item.fotoUrl" :src="data.item.fotoUrl"></v-img>
                    <v-icon v-else>mdi-account-circle</v-icon>
                  </v-avatar>
                  {{ data.item.nome }}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-textarea
              v-model="mensagem"
              label="Texto da Notificação"
              outlined
              dense
              counter="250"
              maxlength="250"
              clearable
              auto-grow
              rows="3"
              prepend-inner-icon="mdi-message-text"
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row justify="end" class="mt-2">
          <v-col cols="12" md="auto">
            <v-btn color="primary" large type="submit">
              <v-icon left>mdi-send</v-icon>
              Enviar
            </v-btn>
          </v-col>
        </v-row>

      </v-form>
    </v-card>
    <v-snackbar
        v-model="snackbar.active"
        :color="snackbar.color"
        :multi-line="snackbar.multiLine"
        :timeout="snackbar.timeout"
        :vertical="snackbar.vertical"
      >
        {{ snackbar.text }}
      </v-snackbar>
    </v-container>
</template>

<script>
export default {
  data() {
    return {
      titulo: "",
      mensagem: "",
      destinatario: "Todos (Geral)", 
      tiposDeDestinatario: [
        'Todos (Geral)',
        'Todos os Pacientes',
        'Todos os Fisioterapeutas',
        'Paciente Específico',
        'Fisioterapeuta Específico'
      ],
      destinatarioSelecionado: null,
      destinatariosEspecificos: [], 
      resposta: null,
      pacientes: [],
      fisioterapeutas: [],
      notificacoes: [],
      pagina: 1,
      totalPaginas: 1,
      buscaTermo: "",
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
    };
  },
  computed: {
    mostrarSelecaoEspecifica() {
      return this.destinatario === 'Paciente Específico' || this.destinatario === 'Fisioterapeuta Específico';
    },
    listaSelecionavel() {
      if (this.destinatario === 'Paciente Específico') {
        return this.pacientes;
      }
      if (this.destinatario === 'Fisioterapeuta Específico') {
        return this.fisioterapeutas;
      }
      return [];
    },
    labelSelecaoEspecifica() {
        return this.destinatario === 'Paciente Específico' 
            ? 'Buscar e selecionar paciente(s)' 
            : 'Buscar e selecionar fisioterapeuta(s)';
    }
  },
  watch: {
    destinatario(novoValor) {
      if (novoValor !== 'Paciente Específico' && novoValor !== 'Fisioterapeuta Específico') {
        this.destinatariosEspecificos = [];
      }
    }
  },
  methods: {
    async enviarNotificacao() {
      try {
        let payload = {
          title: this.titulo,
          body: this.mensagem,
        }

        if (this.destinatario === 'Todos (Geral)') {
          payload.topic = 'todos-usuarios'
        } else if (this.destinatario === 'Todos os Pacientes') {
          payload.topic = 'user-paciente'
        } else if (this.destinatario === 'Todos os Fisioterapeutas') {
          payload.topic = 'user-fisioterapeuta'
        }

        if (
          this.destinatario === 'Paciente Específico' || 
          this.destinatario === 'Fisioterapeuta Específico'
        ) {
          if (this.destinatarioSelecionado) {
            payload.id_pessoa = this.destinatarioSelecionado
          }
        }

        await this.$store.dispatch('enviarNotificacao', payload)

        this.showInfo("Notificação enviada com sucesso!")
        
      } catch (err) {
        console.error("Erro ao enviar notificação:", err)
        this.showError("Erro ao enviar notificação. Tente novamente.")
      }
    },
    async buscarPessoas(termo) {
      if (!termo || termo.length < 3) return; 

      let tipo_usuario = null;
      if (this.destinatario === 'Paciente Específico') tipo_usuario = 1;
      if (this.destinatario === 'Fisioterapeuta Específico') tipo_usuario = 2;
      if (!tipo_usuario) return;

      let params = {
        tipo_usuario,
        nome: termo
      };
      try {
        const data = await this.$store.dispatch('pegarPessoas', params);
        const lista = Array.isArray(data) ? data : data.results || [];

        const formatados = lista.map(pessoa => ({
          id_pessoa: pessoa.id_pessoa,
          nome: pessoa.nome + ' ' + (pessoa.sobrenome || ''),
          fotoUrl: pessoa.url_imagem_perfil  || null
        }));

        if (tipo_usuario === 1) {
          this.pacientes = formatados;
        } else if (tipo_usuario === 2) {
          this.fisioterapeutas = formatados;
        }
      } catch (err) {
        console.error("Erro ao buscar pessoas:", err);
      }
    },
    limparBusca() {
      this.buscaTermo = '';
    },
    showInfo (info) {
      this.snackbar.color = 'success'
      this.snackbar.text = info
      this.snackbar.active = true
    },
    showError (error) {
      this.snackbar.color = 'error'
      this.snackbar.text = error
      this.snackbar.active = true
    },
  },
};
</script>


<style scoped>
.v-card {
  transition: all 0.3s ease;
}
.chip-transparente {
  background-color: transparent !important;
  border: 1px solid #111111;
  color: black !important;
  padding: 0 4px;                         
}
.v-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}
</style>